import React from 'react';
import { empty } from '../utils/Validation';

export default class Toast extends React.Component{

    getClassName(){
        let {show, success, message} = this.props;

        let className = "";

        // if(empty(message)){
        //     return null;
        // }

        if(!success){
            className = className.concat("error-msg")
        }else{
            className = className.concat("success-msg");
        }

        return (show) ? className.concat(" active") : className.replace("active", "");
    }

    render(){
        return(
            <div className={this.getClassName()}>{this.props.message}</div>
        )
    }
}